import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=3aba7d74&scoped=true&"
import script from "./TextBox.vue?vue&type=script&lang=ts&"
export * from "./TextBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba7d74",
  null
  
)

export default component.exports